import * as React from "react"
import { batch } from "@preact/signals-react"
import { Box, Grid, Typography } from "@mui/material"
import { ModalSeeker } from "@ui-seeker/core"
import { isEmpty, translateCountryName } from "@ui-seeker/utils"

import { ChipBlock, ConditionsBlock, ListRetailers } from "./@components"
import { isOpenInfo, infoModalRowClick } from "./@signals"


const EmptyCell = ({ text='All selected' }) => <Typography variant="caption" color="textSecondary">
        {text}
    </Typography>

export default function InfoModal() {

    const {
        reportName = '',
        emails = [],
        brands = [],
        retailers = [],
        country = [],
        skuGroup = null,
        sku = [],
        frequency = '',
        conditionsLabel = {}
    } = infoModalRowClick.value || {};

    const controller = () => batch(() => {

        isOpenInfo.value = false
        infoModalRowClick.value = {}
    })

    const marketsToShow = country?.map((item) => ({
        data: {
            country: item,
            label: translateCountryName(item)
        }
    }))
    const brandsToShow = brands?.map((brand) => brand.name)
    const skuGroupsToShow = skuGroup?.map((group) => group.name)
    const skusToShow = sku?.map((skuName) => skuName.name)

    return <ModalSeeker isOpen={isOpenInfo.value} controller={controller} size="md" hideActions title='Report Details'>
        <Grid container spacing={3}>
            <Grid item xs={12}>
                <Box sx={{ display: 'flex',flexWrap: 'wrap', alignItems: 'center' }}>
                    <Typography variant="subtitle2" className="label" sx={{ display: "inline", mr: 0.5, fontSize: "0.8rem" }}>
                            Report Name:
                    </Typography>
                    {!!reportName ? reportName : <EmptyCell />}
                </Box>
            </Grid>

            <Grid item xs={12}>
                <Box sx={{ display: 'flex',flexWrap: 'wrap', alignItems: 'center' }}>
                    <Typography variant="subtitle2" className="label" sx={{ display: "inline", mr: 0.5, fontSize: "0.8rem" }}>
                            User Email:
                    </Typography>
                    {!!emails ? <ChipBlock listElements={emails} /> : <EmptyCell />}
                </Box>
            </Grid>

            <Grid item xs={12}>
                <Box sx={{ display: 'flex',flexWrap: 'wrap', alignItems: 'center' }}>
                    <Typography variant="subtitle2" className="label" sx={{ display: "inline", mr: 0.5, fontSize: "0.8rem" }}>
                            Frequency:
                    </Typography>
                    {!!frequency ? frequency : <EmptyCell />}
                </Box>
            </Grid>

            <Grid item xs={12}>
                <Box sx={{ display: 'flex',flexWrap: 'wrap', alignItems: 'center' }}>
                    <Typography variant="subtitle2" className="label" sx={{ display: "inline", mr: 0.5, fontSize: "0.8rem" }}>
                            Conditions:
                    </Typography>
                    {isEmpty(conditionsLabel) ? <EmptyCell /> : <ConditionsBlock conditions={conditionsLabel} />}
                </Box>
            </Grid>

            
            <Grid item xs={12}>
                <Box sx={{ display: 'flex',flexWrap: 'wrap', alignItems: 'center' }}>
                    <Typography variant="subtitle2" className="label" sx={{ display: "inline", mr: 0.5, fontSize: "0.8rem" }}>
                        Markets:
                    </Typography>
                    {!!country ? <ListRetailers retailers={marketsToShow} /> : <EmptyCell />}
                </Box>
            </Grid>

            <Grid item xs={12}>
                <Box sx={{ display: 'flex',flexWrap: 'wrap', alignItems: 'center' }}>
                    <Typography variant="subtitle2" className="label" sx={{ display: "inline", mr: 0.5, fontSize: "0.8rem" }}>
                            Brands:
                    </Typography>
                    {!!brands ? <ChipBlock listElements={brandsToShow} /> : <EmptyCell />}
                </Box>
            </Grid>

            <Grid item xs={12}>
                <Box sx={{ display: 'flex',flexWrap: 'wrap', alignItems: 'center' }}>  
                    <Typography variant="subtitle2" className="label" sx={{ display: "inline", mr: 0.5, fontSize: "0.8rem" }}>
                            Retailers:
                    </Typography>
                    {!!retailers ? <ListRetailers retailers={retailers} /> : <EmptyCell />}
                </Box> 
            </Grid>
            
            <Grid item xs={12}>
                <Box sx={{ display: 'flex',flexWrap: 'wrap', alignItems: 'center' }}>  
                    <Typography variant="subtitle2" className="label" sx={{ display: "inline", mr: 0.5, fontSize: "0.8rem" }}>
                            Skus Group:
                    </Typography>
                    {!!skuGroup ? <Typography>{skuGroupsToShow}</Typography> : <EmptyCell />}
                </Box> 
            </Grid>
            
            <Grid item xs={12}>
                <Box sx={{ display: 'flex',flexWrap: 'wrap', alignItems: 'center' }}>  
                    <Typography variant="subtitle2" className="label" sx={{ display: "inline", mr: 0.5, fontSize: "0.8rem" }}>
                            Skus:
                    </Typography>
                    {!!sku ? <ChipBlock listElements={skusToShow} sx={{ maxHeight: 400, overflowY: 'auto' }}  /> : <EmptyCell />}
                </Box> 
            </Grid>
        </Grid>
    </ModalSeeker>
}